import { dataguard } from '@/renderer/utils/vike/dataguard';

export async function data(pageContext: Vike.PageContext) {
  // The whole `(guarded)/` group is `ssr:false` (see `+config.ts`), so nothing
  // auth-gated is server-rendered. `deferAuthToClientOnServer` stops a server render
  // with no `sid` cookie from bouncing to /signin (the server can't read the
  // localStorage Bearer session) and instead lets the client — which can — decide.
  // Fixes mobile-Chrome re-login-on-every-refresh (#1405). A logged-out client still
  // lands on /signin via this same guard + the `Guarded` wrapper.
  return await dataguard(pageContext, { deferAuthToClientOnServer: true });
}
